import { NETWORK_NAME_LABELS } from 'src/utils/constants';
import './Portfolio.css';
import { useEffect, useState } from 'react';
import RoundPaginationButtons from '../round-pagination-buttons/RoundPaginationButtons';
import { removeTrailingZeros } from 'src/utils/strings';

const COINS_PER_PORTFOLIO_PAGE = 10;

const Portfolio = ({ balances, prices }) => {
    const pages = Math.ceil(balances.length / COINS_PER_PORTFOLIO_PAGE);

    const [currentPage, setCurrentPage] = useState(1);
    const [balancesToShow, setBalancesToShow] = useState(balances.slice(0, COINS_PER_PORTFOLIO_PAGE));

    useEffect(() => {
        setBalancesToShow(
            balances.slice((currentPage - 1) * COINS_PER_PORTFOLIO_PAGE, COINS_PER_PORTFOLIO_PAGE * currentPage)
        );
    }, [balances, currentPage]);

    const onNextClick = () => {
        if (currentPage === pages) return;
        setCurrentPage(currentPage + 1);
    };

    const onPrevClick = () => {
        if (currentPage === 1) return;
        setCurrentPage(currentPage - 1);
    };

    return (
        <div className="my-8">
            <span className="mb-4 block">Portfolio</span>
            {balances.length === 0 && (
                <div className="empty-portfolio w-full h-72 bg-gray-light rounded-xl flex flex-col items-center justify-center">
                    <span className="font-bold">Your portfolio is empty</span>
                </div>
            )}
            {balancesToShow.map((balance, i) => (
                <div className="bg-gray-light rounded-xl flex px-6 py-4 mt-2" key={i}>
                    <img
                        src={`/crypto-icons/${balance.token.toLowerCase()}.svg`}
                        alt={`${balance.token} icon`}
                        width={40}
                        className="mr-2"
                    />
                    <div className="flex flex-col">
                        <span className="text-lg">{balance.token}</span>
                        <span className="text-xs text-gray-darker">
                            On the {NETWORK_NAME_LABELS[balance.network]} network
                        </span>
                    </div>
                    <div className="flex flex-col ml-auto">
                        <span className="text-md text-right">
                            {removeTrailingZeros(balance.amount.toFixed(8))} {balance.token}
                        </span>
                        <span className="text-xs text-gray-darker text-right mt-auto">
                            ≈ ${(balance.amount * prices[balance.token]).toFixed(2)}
                        </span>
                    </div>
                </div>
            ))}
            {pages > 1 && (
                <RoundPaginationButtons
                    currentPage={currentPage}
                    pages={pages}
                    onPrevClick={onPrevClick}
                    onNextClick={onNextClick}
                />
            )}
        </div>
    );
};

export default Portfolio;
